import { combineReducers } from 'redux';

import { projectOverviewMainState } from '../../redux/project-overview/project-overview.reducers';
import { ProjectOverviewMainState } from '../../redux/project-overview/project-overview.types';

import {
  ProjectOverviewMembersUiState,
  projectOverviewMembersUiState,
} from './project-overview-members/project-overview-members.reducer-ui';

export interface ProjectOverviewState {
  projectOverviewMainState: ProjectOverviewMainState;
  projectOverviewMembersUiState: ProjectOverviewMembersUiState;
}

export const projectOverviewState = combineReducers<ProjectOverviewState>({
  projectOverviewMainState,
  projectOverviewMembersUiState,
});
